/**
 * Offline support: registers the service worker (src/sw.js), which keeps the
 * kiosk on the site when the network is down.
 *
 * Kiosks only. An ordinary visitor of the site must not end up downloading the
 * 31 MB lockscreen video and every member photo in the background. And never
 * on the development server, which would then serve stale files.
 */
import { readIdentity } from './heartbeat';

export default function startOffline() {
  if (process.env.NODE_ENV !== 'production'
    || !('serviceWorker' in navigator)
    || readIdentity() === null) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // No offline support then, but the kiosk works exactly as before.
    });
  });
}
